import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { apiGetOrgunits, apiUpdateOrgunits } from "../../../api/ApiOrgunit";
import { apiGetPersonne, apiUpdatePersonne } from "../../../api/ApiPersonnes";
import { BiSubdirectoryRight } from "react-icons/bi";

const ModalChoixOrgunits = (props) => {
  const { t } = useTranslation();
  const { idPersonne, ReduxInstanceId, show, handleClose } = props;
  const [orgunits, setOrgunits] = useState([]);
  const [personneModal, setPersonneModal] = useState({
    orgUnitsParent: [],
    orgUnitsInitiaux: [],
    orgUnitsModifies: [],
  });
  const [isModified, setIsModified] = useState(false);

  const recupPersonne = async () => {
    const res = await apiGetPersonne(ReduxInstanceId, idPersonne);
    res.data.orgUnitsInitiaux = res.data.orgUnitsParent;
    res.data.orgUnitsModifies = [];
    setPersonneModal(res.data);
  };

  const recupOrgunits = async () => {
    const res = await apiGetOrgunits(ReduxInstanceId);
    setOrgunits(res.data);
  };

  const addRemoveOrgunit = async (idOrgunit) => {
    setIsModified(true);
    let orgUnitsParent = [...personneModal.orgUnitsParent];
    let orgUnitsInitiaux = [...personneModal.orgUnitsInitiaux];
    let orgUnitsModifies = [...personneModal.orgUnitsModifies];

    // retrait d'un orgunit du tableau
    if (orgUnitsParent.includes(idOrgunit)) {
      orgUnitsParent = orgUnitsParent.filter((item) => item !== idOrgunit);
      // orgunit deja present à l'origine, donc on notifie une modif de cet orgunit car on lui retire un membre
      if (orgUnitsInitiaux.includes(idOrgunit)) {
        orgUnitsModifies.push(idOrgunit);
      }
      // orgunit non present à l'origine cela signifie qu'a un moment on a rajoute ce orgunit visuellement sans sauvegrader et qu'on l'a retire ensuite donc pas la peine de notifier ce changement sur le orgunt
      else {
        orgUnitsModifies = orgUnitsModifies.filter((item) => item !== idOrgunit);
      }
    }
    // ajout d'un orgunit au tableau
    else {
      orgUnitsParent.push(idOrgunit);
      // orgunit deja present à l'origine, donc cela signifie qu'on l'a deciché puis recoche, donc aucun besoin de notifier le changement
      if (orgUnitsInitiaux.includes(idOrgunit)) {
        orgUnitsModifies = orgUnitsModifies.filter((item) => item !== idOrgunit);
      }
      // orgunit non present à l'origine, donc on notifie une modif de cet orgunit car on lui ajoute un membre
      else {
        orgUnitsModifies.push(idOrgunit);
      }
    }

    setPersonneModal({
      ...personneModal,
      orgUnitsParent: orgUnitsParent,
      orgUnitsModifies: orgUnitsModifies,
    });
  };

  const saveBeforeClose = async () => {
    if (isModified) {
      const formData = new FormData();
      const formDataModifs = [];

      personneModal.orgUnitsParent.forEach((element) => {
        formData.append("orgUnitsParent[]", element);
      });

      personneModal.orgUnitsModifies.forEach((element) => {
        formDataModifs.push({ _id: element });
      });

      await apiUpdateOrgunits(formDataModifs);
      await apiUpdatePersonne(idPersonne, formData);
    }
    handleClose();
  };

  useEffect(() => {
    if (show) {
      setIsModified(false);
      recupPersonne();
      recupOrgunits();
    }
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  const RecursiveComponentOrgUnit = ({ objet, childrens, niveau }) => {
    let hasChildren = false;
    if (childrens && childrens.length) hasChildren = true;

    return (
      <>
        <InputGroup className="">
          {niveau !== 0 && (
            <BiSubdirectoryRight
              size="1.5em"
              className={"text-danger"}
              style={{ marginLeft: niveau * 15 + "px" }}
            />
          )}
          <Form.Check
            role="button"
            id={"orgunit_" + objet._id}
            type="switch"
            label={objet.nom}
            value={objet._id}
            onChange={(e) => {
              addRemoveOrgunit(e.target.value);
            }}
            checked={personneModal.orgUnitsParent.includes(objet._id) ? "checked" : ""}
          />
        </InputGroup>
        {hasChildren &&
          childrens.map((enfant) => (
            <RecursiveComponentOrgUnit
              key={enfant._id}
              objet={enfant}
              childrens={orgunits.filter((item) => item.orgUnitParent === enfant._id)}
              niveau={niveau + 1}
            />
          ))}
      </>
    );
  };

  return (
    <Modal show={show} onHide={saveBeforeClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("admin.PageAdminCollaborateurs.groupes")} {personneModal.prenom} {personneModal.nom}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* ORGUNITS LEVEL 0 */}
        {orgunits
          .filter((orgunit) => orgunit.orgUnitParent === null)
          .map((orgunit) => (
            <RecursiveComponentOrgUnit
              key={orgunit._id}
              objet={orgunit}
              childrens={orgunits.filter((item) => item.orgUnitParent === orgunit._id)}
              niveau={0}
            />
          ))}
      </Modal.Body>
    </Modal>
  );
};

export default ModalChoixOrgunits;
